// extracted by mini-css-extract-plugin
export default {"img_logo":"Navbar_img_logo__NoDze"};